export default "__VITE_ASSET__b024404b__"